import { CommonModule, isPlatformBrowser } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, PLATFORM_ID } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BootstrapModalService } from '../../../core/services/bootstrap-modal.service';
import { FlashMessageService } from '../flash-message/flash-message.service';

@Component({
  selector: 'app-marketing-actions',
  imports: [CommonModule, TranslateModule],
  templateUrl: './marketing-actions.component.html',
  styleUrl: './marketing-actions.component.scss'
})
export class MarketingActionsComponent {
  isBrowser: boolean;

  // Selected packages per section
  selectedDemPackage: string = '';
  selectedCampagnePackage: string = '';
  selectedFeedPackage: string = '';
  selectedSidebarPackage: string = '';
  selectedLogoPackage: string = '';
  selectedIframe: boolean = false;

  // Track validation error state per section
  validationErrors: Record<string, boolean> = {};

  // Track continuous blink animation state per section
  blinkSection: Record<string, boolean> = {};

  requestedServiceKey: string = '';
  requestedPackageKey: string = '';

  constructor(
    @Inject(PLATFORM_ID) private readonly platformId: any,
    public readonly translate: TranslateService,
    private readonly bootstrapModalService: BootstrapModalService,
    private readonly flashMessage: FlashMessageService,
    private readonly cdr: ChangeDetectorRef
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  selectDem(pkgKey: string) {
    this.selectedDemPackage = this.selectedDemPackage === pkgKey ? '' : pkgKey;
    if (this.selectedDemPackage) {
      this.validationErrors = { ...this.validationErrors, dem: false };
      this.blinkSection = { ...this.blinkSection, dem: false };
      this.cdr.detectChanges();
    }
  }

  selectCampagne(pkgKey: string) {
    this.selectedCampagnePackage = this.selectedCampagnePackage === pkgKey ? '' : pkgKey;
    if (this.selectedCampagnePackage) {
      this.validationErrors = { ...this.validationErrors, campagne: false };
      this.blinkSection = { ...this.blinkSection, campagne: false };
      this.cdr.detectChanges();
    }
  }

  selectFeed(pkgKey: string) {
    this.selectedFeedPackage = this.selectedFeedPackage === pkgKey ? '' : pkgKey;
    if (this.selectedFeedPackage) {
      this.validationErrors = { ...this.validationErrors, feed: false };
      this.blinkSection = { ...this.blinkSection, feed: false };
      this.cdr.detectChanges();
    }
  }

  selectSidebar(pkgKey: string) {
    this.selectedSidebarPackage = this.selectedSidebarPackage === pkgKey ? '' : pkgKey;
    if (this.selectedSidebarPackage) {
      this.validationErrors = { ...this.validationErrors, sidebar: false };
      this.blinkSection = { ...this.blinkSection, sidebar: false };
      this.cdr.detectChanges();
    }
  }

  selectLogo(pkgKey: string) {
    this.selectedLogoPackage = this.selectedLogoPackage === pkgKey ? '' : pkgKey;
    if (this.selectedLogoPackage) {
      this.validationErrors = { ...this.validationErrors, logo: false };
      this.blinkSection = { ...this.blinkSection, logo: false };
      this.cdr.detectChanges();
    }
  }

  toggleIframe() {
    this.selectedIframe = !this.selectedIframe;
    if (this.selectedIframe) {
      this.validationErrors = { ...this.validationErrors, iframe: false };
      this.blinkSection = { ...this.blinkSection, iframe: false };
      this.cdr.detectChanges();
    }
  }

  onContact(serviceKey: string, pkgKey?: string, requiresPackage: boolean = true, sectionId?: string) {
    if (requiresPackage && !pkgKey) {
      if (sectionId) {
        this.validationErrors = { ...this.validationErrors, [sectionId]: true };
        this.blinkSection = { ...this.blinkSection, [sectionId]: true };
        this.cdr.detectChanges();
      }
      this.flashMessage.showErrorAlert(this.translate.instant('mkt_select_package_alert'));
      return;
    }

    if (sectionId) {
      this.validationErrors = { ...this.validationErrors, [sectionId]: false };
      this.blinkSection = { ...this.blinkSection, [sectionId]: false };
      this.cdr.detectChanges();
    }

    this.requestedServiceKey = serviceKey;
    this.requestedPackageKey = pkgKey || '';
    if (this.isBrowser) {
      this.bootstrapModalService.open('marketingContactModal', {
        backdrop: 'static',
        keyboard: false
      });
    }
  }

  closeModal() {
    if (this.isBrowser) {
      this.bootstrapModalService.close('marketingContactModal');
    }
  }
}
